module.exports = __webpack_public_path__ + "tie.jpg?3f0bafe12c5505c0a766f10f2981acdb";